module.exports = __webpack_public_path__ + "static/media/loading.8a8a99d1.svg";